import { useEffect, useState } from "react";

const Badge = ({
  color,
  children,
  size = "xs",
  customColor,
  slim=false,
  ...rest
}) => {
  const [className, setClassName] = useState("");
  useEffect(() => {
    let classes = [
      "text" + (size ? "-" + size : ""),
      "inline-flex",
      "font-medium",
      "rounded-full",
      "text-center",

    ];
    if(!slim){
      classes.push("px-2.5 py-1");
    }else{
      classes.push("px-2 py-0.5");
    }

    switch (color) {
      case "purple":
        classes.push(
          "bg-indigo-100 dark:bg-indigo-500/30 text-indigo-600 dark:text-indigo-400"
        );
        break;
      case "blue":
        classes.push(
          "bg-sky-100 dark:bg-sky-500/30 text-sky-600 dark:text-sky-400"
        );
        break;
      case "green":
        classes.push(
          "bg-emerald-100 dark:bg-emerald-400/30 text-emerald-600 dark:text-emerald-400 "
        );
        break;
      case "yellow":
        classes.push(
          "bg-amber-100 dark:bg-amber-400/30 text-amber-600 dark:text-amber-400"
        );
        break;
      case "red":
        classes.push(
          "bg-rose-100 dark:bg-rose-500/30 text-rose-500 dark:text-rose-400"
        );
        break;
      case "orange":
        classes.push(
          "bg-orange-100 dark:bg-orange-500/30 text-orange-600 dark:text-orange-400"
        );
        break;
      case "gray":
        classes.push(
          "bg-blue-100 dark:bg-blue-500/30 text-blue-600 dark:text-blue-500"
        );
        break;
      case "dark":
        classes.push(
          "bg-slate-100 dark:bg-slate-300 text-slate-500 dark:text-slate-600"
        );
        break;
    }
    if(customColor){
      classes.push(customColor);
    }
    setClassName(classes.join(" "));
  }, [color, customColor, size]);

  return (
    <div className={className}>
      {children}
    </div>
  );
};

export default Badge;